import axios from 'axios';
import { Config } from '../config';
import { TokenDto, LoginDto, UserInforDto } from '@/model/user.dto';

export class UserApi {
  public async getNewToken(refreshToken: string): Promise<TokenDto> {
    const url = `${Config.API_URL}/user/reissue`;
    const headers = {
      Authorization: `Bearer ${refreshToken}`,
      'Content-Type': 'application/json',
    };
    const res = await axios.get<TokenDto>(url, { headers });
    return res.data;
  }
  public async getMyInfor(accessToken: string): Promise<UserInforDto> {
    const url = `${Config.API_URL}/user/profile`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const res = await axios.get<UserInforDto>(url, { headers });
    return res.data;
  }

  public async postLogin(dto: LoginDto): Promise<TokenDto | null> {
    try {
      const url = `${Config.API_URL}/user/signin`;
      const res = await axios.post<TokenDto>(url, dto);
      return res.data;
    } catch (err) {
      return null;
    }
  }
}
